import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Message from './layouts/Message';
import Home from './pages/Home';
import Wlist from './pages/Wlist';
import Body from './pages/Body';
import Profil from './pages/Profil';
import Access from './pages/Access';
import Meeting from './pages/Meeting';
import Registration from './pages/Registration';
import Error from './pages/Error';

import './App.css';

function App() {
    const status = useSelector(state => state.profil.status);

    return (
        <React.StrictMode>
            <Message />
            
            <Routes>
                {/* Redirection de / vers /home */}
                <Route path="/" element={<Navigate to="/home" replace />} />

                {/* Route pour /home */}
                <Route path="/home" element={<Body />}>
                    <Route index element={<Home />} />
                    <Route path="profil" element={<Profil />} />
                    <Route path="access" element={<Access />} />
                    <Route path="meeting" element={<Meeting />} />

                    {status === 'admin' && <Route path="wlist" element={<Wlist />} />}
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Route>

                <Route path="/signup" element={<Registration />} />
                {/* Route pour les URLs invalides (404) */}
                <Route path="*" element={<Error />} />
            </Routes>
        </React.StrictMode>
    );
}

export default App;